export default String.raw`
.infographicBanner {
    width: 100%;
    position: relative;
    padding: 0 9%;

    &__swiper {
        padding: 0;
    }

    &__slide {
        width: calc(100% / 5);
        &-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 16px;

            &-text {
                h3 {
                    @include body-1-medium;
                    margin-bottom: 16px
                }
    
                p {
                    @include body-2-regular;
                }
    
                h3, p {
                    text-align: center;
                    color: $primaryColorFont;
                }
            }

            &-circle {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                border: 2px solid $lightBorderColor;
                width: 64px;
                height: 64px;
                min-width: 64px;
                min-height: 64px;
            }
        }
    }

    &__prev, &__next {
        position: absolute;
        z-index: 90;
        top: calc(50% - 24px);

        svg {
            width: 16px;
            height: 16px;
        }
    }

    &__prev {
        left: calc(-24px + 9%);

        svg {
            rotate: 180deg;
        }
    }

    &__next {
        right: calc(-24px + 9%);
    }
}
`